// extracted by mini-css-extract-plugin
export default {"button":"InterviewsTable-module__button__TrFRC","startInterviewButton":"InterviewsTable-module__startInterviewButton__V0Zl6"};